import React from "react";

const DraggableWrapper = ({
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  id,
  children,
}) => {
  return (
    <div
      // className="box"
      // style={{ backgroundColor: box.color }}
      draggable={draggable}
      onDragStart={onDragStart && onDragStart({ id })}
      onDragOver={onDragOver && onDragOver({ id })}
      onDrop={onDrop && onDrop({ id })}
    >
      {children}
    </div>
  );
};

export default DraggableWrapper;
